<template>
  <div class="voloro-btns">
    <a
      href="https://vbank.invest.demo.securitize.io/"
      data-securitize-action="main"
      data-securitize-logged-in-action="dashboard"
      data-securitize-logged-in-text="Invest Now"
      data-securitize-logged-out-action="main"
      data-securitize-logged-out-text="Register as Investor"
      class="voloro-btns__register flex-center"
      :class="[blueviolet ? 'bg-blueviolet text-white' : 'text-blueviolet bg-white']"
    >
      Register as investor
    </a>
    <a
      href="https://id.demo.securitize.io/#/authorize?issuerId=854ed626-e79f-487e-8800-931e2ab87ebf&scope=info%20details%20verification&redirecturl=https://vbank.invest.demo.securitize.io/#/authorize"
      data-securitize-action="login"
      data-securitize-logged-in-action="logout"
      data-securitize-logged-in-text="Logout"
      data-securitize-logged-out-action="login"
      data-securitize-logged-out-text="Login"
      class="voloro-btns__sign-in arrow-right flex-center ml-md-4"
      :class="[blueviolet ? 'text-blueviolet' : 'text-white']"
    >
      Login
    </a>
  </div>
</template>

<script>
  export default {
    name: 'BtnGroup',
    props: {
      blueviolet: {
        type: Boolean,
        default: false,
      }
    },
  }
</script>

<style lang="scss" src="./BtnGroup.scss" />
